<template>
    <div>
        <div class="text-center">
            <div style="font-size: 16px;">
                <strong v-if="!cedis">Venta por Cedis y Desglose por Vendedores</strong>
                <strong v-if="cedis">Vendedores con Ventas<br />{{sellers_with_sales}} de {{sellers}}</strong>
            </div>
        </div>        
        <div style="width: 100%; height: 1600px;" ref="monthSalesCedisGraph" @wheel="forwardWheelToPage">                            
        </div>
    </div>
</template>

<script>
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

import ws from '../../services/dashboards';
import store from '../../store'

export default {
    name: 'MonthSalesCedis',
    props: {
        permissions: {
            type: Object,
            default() {
                return {}
            }
        },
        title: {
            type: String,
            default() {
                return "Venta de Cedis"
            }
        },
        month: {
            type: String,
            default: '202401'
        }              
    },
    components : {
	},
    data: function () {
		return {
            data: {},
            items: {},
            root: "",
            chart: "",
            xAxis:"",
            yAxis:"",
            wheelX: false,
            wheelY: false,
            data_response:"",
            legend:"",
            cedis: 0,
            sellers_with_sales: 0,
            sellers: 0
        }
    },
    computed: {
        
    },
    mounted: async function(){        
        this.loading();

        let response = await ws.getMonthsSalesCedis(this.month);

        if(response.type == "success"){
            this.data = response.data.data;
            this.loadGraph(this.data);
        }

        this.loaded();
    },
    methods: {
        makeSeries(field, name, root, data_response) {
            let series = this.chart.series.push(am5xy.ColumnSeries.new(root, {
                name: name,
                xAxis: this.xAxis,
                yAxis: this.yAxis,
                wheelX: false,
                wheelY: false,
                valueXField: field,
                categoryYField: "ejeY",
                sequencedInterpolation: true,
                tooltip: am5.Tooltip.new(root, {
                    pointerOrientation: "horizontal",
                    labelText: "[bold]{name}[/]\n{categoryY}: {valueX}"
                })
            }));

            series.columns.template.setAll({
                height: am5.p100,
                strokeOpacity: 0
            });


            series.bullets.push(function () {
                return am5.Bullet.new(root, {
                locationX: 1,
                locationY: 0.5,
                sprite: am5.Label.new(root, {
                    centerY: am5.p50,
                    text: "{valueX}",
                    populateText: true,
                    fontSize:10,
                })
                });
            });

            series.data.setAll(data_response);
            series.appear();

            return series;
        },
        async loadGraph(data,bar_label = "Cedis"){
            if (this.root) {
                this.root.dispose();
            }

            this.root = am5.Root.new(this.$refs.monthSalesCedisGraph);

            this.root.setThemes([
                am5themes_Animated.new(this.root)
            ]);
            
            this.chart = this.root.container.children.push(am5xy.XYChart.new(this.root, {
                panX: false,
                panY: false,
                wheelX: 'none',
                wheelY: 'none',
                pinchZoomX: false,
                pinchZoomY: false,
                paddingLeft:0,
                layout: this.root.verticalLayout
            }));

            this.legend = this.chart.children.push(am5.Legend.new(this.root, {
                centerX: am5.p50,
                x: am5.p50
            }));

            this.yAxis = this.chart.yAxes.push(am5xy.CategoryAxis.new(this.root, {
                categoryField: "ejeY",
                renderer: am5xy.AxisRendererY.new(this.root, {
                    inversed: true,
                    cellStartLocation: 0.1,
                    cellEndLocation: 0.9,
                    minGridDistance: 1, 
                })
            }));
            this.yAxis.get("renderer").labels.template.setAll({
                fontSize: 11, // Cambia este valor al tamaño de letra que desees
                minGridDistance: 1, // Asegura que no se agrupen las categorías
                forceHidden: false, // Asegura que las etiquetas no se oculten
            });

            this.yAxis.set("interpolationDuration", 0);
            this.yAxis.data.setAll(data);        
            
            this.xAxis = this.chart.xAxes.push(am5xy.ValueAxis.new(this.root, {
                renderer: am5xy.AxisRendererX.new(this.root, {
                    strokeOpacity: 0.1,
                    minorGridEnabled: false,
                }),
                min: 0
            }));

            
            this.xAxis.get("renderer").labels.template.set("forceHidden", false);


            this.makeSeries("ejeX", bar_label,this.root, data);

            this.legend = this.chart.children.push(am5.Legend.new(this.root, {
                centerX: am5.p50,
                x: am5.p50
            }));

            this.legend.data.setAll(this.chart.series.values);            

            let cursor = this.chart.set("cursor", am5xy.XYCursor.new(this.root, {
                behavior: "none"
            }));
            cursor.lineY.set("forceHidden", true);
            cursor.lineX.set("forceHidden", true);

            this.chart.appear(1000, 100);
         
        },
        async reloadGraph(month, brand,cedis){
            this.loading();

            this.cedis = cedis;

            let response = await ws.getMonthsSalesCedis(month, brand,cedis);

            if(response.type == "success"){
                this.data = response.data.data;
                this.sellers = response.data.sellers;
                this.sellers_with_sales = response.data.sellers_with_sales;
                this.loadGraph(this.data, (cedis > 0) ? "Vendedor" :"Cedis");
            }

            this.loaded();
        },
        forwardWheelToPage(event){
            if (event && event.defaultPrevented) {
                window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
            }
        },
        loading(){
            store.commit('loading');
        },
        loaded(){
            store.commit('loaded');
        }
    },
    beforeDestroy() {
        if (this.root) {
            this.root.dispose();
        }
  }
}

</script>
